<div [ngClass]="{'text-end':col.align==='right', 'text-start':col.align==='left'}">
  {{col.header}}
  <p-sortIcon [field]="col.field"></p-sortIcon>
</div>